module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "in-out"
    }
  }, [((!_vm.isPortrait && !_vm.is404)) ? _c('div', {
    staticClass: "orientation-warning-mobile",
    style: ({
      backgroundColor: _vm.cssPropColor('$color-primary')
    })
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('h1', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.heading)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro",
    domProps: {
      "innerHTML": _vm._s(_vm.content.text)
    }
  })])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-62b6fa7a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/OrientationWarningMobile.vue
// module id = 459
// module chunks = 1